exports = module.exports = require("../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".am-whitespace.am-whitespace-xs {\n  height: 3px;\n}\n.am-whitespace.am-whitespace-sm {\n  height: 6px;\n}\n.am-whitespace.am-whitespace-md {\n  height: 9px;\n}\n.am-whitespace.am-whitespace-lg {\n  height: 15px;\n}\n.am-whitespace.am-whitespace-xl {\n  height: 21px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/less-loader/dist/cjs.js??ref--1-oneOf-2-3!./node_modules/antd-mobile/lib/white-space/style/index.less
// module id = 1177
// module chunks = 0 2 3 4 5 6 8 9 10 11 12 13 14 15 18 21 22 24 26 32 33 48 54